var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full h-full",staticStyle:{"min-height":"3000px"}},[_c('iframe',{staticClass:"w-full",staticStyle:{"min-height":"3000px"},attrs:{"src":_vm.url,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }